import { FeatureListTable } from "./feature-list/FeatureListTable";

export const FeaturesPage = () => {
	return <FeatureListTable />;
};
